import { useContext } from "react";
import { AppContext } from "../App";
import { formatAdminRole } from "../accessControl";
import { MdArrowOutward, MdPhone, MdSecurity } from "react-icons/md";

export default function One({ data }) {
  const appContext = useContext(AppContext);

  function view() {
    appContext.navTo({
      item: "side-view",
      subItem: "admin-options",
      extraItem: data.id,
    });
  }

  return (
    <button
      type="button"
      className="quick-link-card text-start"
      onClick={view}
      style={{ width: "100%" }}
    >
      <span className="quick-link-icon">
        <MdSecurity />
      </span>
      <span className="quick-link-copy">
        <strong>{data.fullname}</strong>
        <small className="d-flex flex-wrap align-items-center gap-3">
          <span>{formatAdminRole(data.role)}</span>
          <span className="d-flex align-items-center gap-1">
            <MdPhone size={12} />
            {data.phone || "No phone"}
          </span>
        </small>
      </span>
      <span className="quick-link-action">
        View
        <MdArrowOutward />
      </span>
    </button>
  );
}
